var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, getTestId, Input, InView, isLastItem, LILAC_500, LILAC_600, Loader, Typography, WHITE } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { getInputWidgetStyles } from './InputWidgetStyles';
import { filterAutoCompleteValues } from './InputWidgetUtils';
import { FlatList } from 'react-native-gesture-handler';
export var InputWidgetComponent = props => {
  var id = props.id,
    prependItems = props.prependItems,
    appendItems = props.appendItems,
    onHintActionPress = props.onHintActionPress,
    _props$showInputDivid = props.showInputDivider,
    showInputDivider = _props$showInputDivid === void 0 ? true : _props$showInputDivid,
    enableAutocomplete = props.enableAutocomplete,
    _props$autoCompleteDa = props.autoCompleteData,
    autoCompleteData = _props$autoCompleteDa === void 0 ? [] : _props$autoCompleteDa,
    _props$autoCompleteFi = props.autoCompleteFilterKey,
    autoCompleteFilterKey = _props$autoCompleteFi === void 0 ? 'title' : _props$autoCompleteFi,
    _props$autoCompleteVa = props.autoCompleteValueKey,
    autoCompleteValueKey = _props$autoCompleteVa === void 0 ? 'title' : _props$autoCompleteVa,
    autoCompleteStyle = props.autoCompleteStyle,
    showListLoader = props.showListLoader,
    style = props.style,
    onPress = props.onPress,
    _onChangeText = props.onChangeText,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    showDivider = props.showDivider,
    _props$value = props.value,
    _value = _props$value === void 0 ? '' : _props$value,
    actionCta = props.actionCta,
    onUserAction = props.onUserAction,
    _onValidInput = props.onValidInput,
    _onInValidInput = props.onInValidInput,
    onClearButtonPress = props.onClearButtonPress,
    onItemVisibleMetaData = props.onItemVisibleMetaData,
    inViewTriggerOnce = props.inViewTriggerOnce,
    _props$shouldFilterOn = props.shouldFilterOnAllFields,
    shouldFilterOnAllFields = _props$shouldFilterOn === void 0 ? false : _props$shouldFilterOn,
    _props$showAutoComple = props.showAutoCompleteOnFocus,
    showAutoCompleteOnFocus = _props$showAutoComple === void 0 ? true : _props$showAutoComple,
    _props$hideAutoComple = props.hideAutoCompleteOnBlur,
    hideAutoCompleteOnBlur = _props$hideAutoComple === void 0 ? false : _props$hideAutoComple,
    _props$showEmptyItemF = props.showEmptyItemForAutoComplete,
    _showEmptyItemForAutoComplete = _props$showEmptyItemF === void 0 ? true : _props$showEmptyItemF,
    _props$hideAutoComple2 = props.hideAutoCompleteOnFilterSelection,
    hideAutoCompleteOnFilterSelection = _props$hideAutoComple2 === void 0 ? false : _props$hideAutoComple2,
    testID = props.testID,
    onChangeTextCallback = props.onChangeTextCallback,
    isForceUpdateRequired = props.isForceUpdateRequired,
    _props$autoCompleteKe = props.autoCompleteKeyboardShouldPersistTaps,
    autoCompleteKeyboardShouldPersistTaps = _props$autoCompleteKe === void 0 ? 'handled' : _props$autoCompleteKe,
    autoCompleteProps = props.autoCompleteProps,
    restProps = __rest(props, ["id", "prependItems", "appendItems", "onHintActionPress", "showInputDivider", "enableAutocomplete", "autoCompleteData", "autoCompleteFilterKey", "autoCompleteValueKey", "autoCompleteStyle", "showListLoader", "style", "onPress", "onChangeText", "onFocus", "onBlur", "showDivider", "value", "actionCta", "onUserAction", "onValidInput", "onInValidInput", "onClearButtonPress", "onItemVisibleMetaData", "inViewTriggerOnce", "shouldFilterOnAllFields", "showAutoCompleteOnFocus", "hideAutoCompleteOnBlur", "showEmptyItemForAutoComplete", "hideAutoCompleteOnFilterSelection", "testID", "onChangeTextCallback", "isForceUpdateRequired", "autoCompleteKeyboardShouldPersistTaps", "autoCompleteProps"]);
  var inputWidgetStyles = getInputWidgetStyles(props);
  var _useState = useState(autoCompleteData),
    listData = _useState[0],
    setListData = _useState[1];
  var _useState2 = useState(_value),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    inputFocus = _useState3[0],
    setInputFocus = _useState3[1];
  var _useState4 = useState(_showEmptyItemForAutoComplete),
    showEmptyItemForAutoComplete = _useState4[0],
    setShowEmptyItemForAutoComplete = _useState4[1];
  var _useState5 = useState(false),
    isAutoSelectionItemPressed = _useState5[0],
    setIsAutoSelectionItemPressed = _useState5[1];
  useEffect(() => {
    setValue(_value);
  }, [_value]);
  useEffect(() => {
    if (isForceUpdateRequired) {
      setValue(_value);
    }
  }, [isForceUpdateRequired]);
  var showAutocomplete = enableAutocomplete && !!(autoCompleteData === null || autoCompleteData === void 0 ? void 0 : autoCompleteData.length) && (showAutoCompleteOnFocus && inputFocus || (!hideAutoCompleteOnBlur || inputFocus) && !!value);
  useEffect(() => {
    filterDataForAutocompleteHandler();
  }, [autoCompleteData]);
  var onActionableHintPressHandler = () => {
    onHintActionPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onHintActionPress)));
  };
  var filterDataForAutocompleteHandler = filterValue => {
    if (enableAutocomplete) {
      if (filterValue) {
        var filteredData = filterAutoCompleteValues(autoCompleteData, autoCompleteFilterKey, filterValue, shouldFilterOnAllFields, hideAutoCompleteOnFilterSelection);
        setListData(filteredData);
      } else {
        setListData(autoCompleteData);
      }
    }
  };
  var singleItemOnPressHandler = data => {
    var autocompleteItem = data.autocompleteItem,
      index = data.index;
    var selectedItemValue = autocompleteItem[autoCompleteValueKey];
    setValue(selectedItemValue);
    if (hideAutoCompleteOnFilterSelection) {
      setListData([]);
      setIsAutoSelectionItemPressed(true);
      setShowEmptyItemForAutoComplete(false);
    }
    onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onPress), {
      autocompleteItem,
      selectedItemValue,
      index
    }));
  };
  var prependItemWithOnPressProps = Object.assign(Object.assign({}, prependItems), {
    onPress: () => (prependItems === null || prependItems === void 0 ? void 0 : prependItems.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, prependItems.onPress)))
  });
  var appendItemWithOnPressProps = Object.assign(Object.assign({}, appendItems), {
    onPress: () => (appendItems === null || appendItems === void 0 ? void 0 : appendItems.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, appendItems.onPress)))
  });
  var SingleItem = item => {
    var _item$autocompleteIte = item.autocompleteItem,
      autocompleteItem = _item$autocompleteIte === void 0 ? {} : _item$autocompleteIte,
      index = item.index;
    var autoCompleteItemId = autocompleteItem.id,
      autoCompleteItemTitle = autocompleteItem.title,
      autoCompleteItemSubTitle = autocompleteItem.subtitle,
      _autocompleteItem$tit = autocompleteItem.titleStyle,
      autoCompleteItemTitleStyle = _autocompleteItem$tit === void 0 ? {} : _autocompleteItem$tit,
      _autocompleteItem$sub = autocompleteItem.subTitleStyle,
      autoCompleteItemSubTitleStyle = _autocompleteItem$sub === void 0 ? {} : _autocompleteItem$sub;
    return _jsxs(Pressable, Object.assign({
      onPress: () => singleItemOnPressHandler({
        autocompleteItem,
        index
      })
    }, {
      children: [_jsxs(View, Object.assign({
        style: inputWidgetStyles.listItemContainer
      }, {
        children: [!!autoCompleteItemTitle && _jsx(Typography, Object.assign({
          style: [!!autoCompleteItemSubTitle && inputWidgetStyles.listItemTitle, autoCompleteItemTitleStyle],
          type: "body-single-line-sm-bold",
          text: autoCompleteItemTitle
        }, getTestId(testID + '_title', index.toString()))), !!autoCompleteItemSubTitle && _jsx(Typography, Object.assign({
          type: "body-single-line-xs",
          style: autoCompleteItemSubTitleStyle,
          text: autoCompleteItemSubTitle
        }, getTestId(testID + '_subtitle', index.toString())))]
      })), !isLastItem(listData, index) && _jsx(Divider, {
        height: 1,
        style: inputWidgetStyles.divider,
        shadowColor: WHITE
      })]
    }), "single_item_autocomolete_" + index + "_" + autoCompleteItemId);
  };
  var EmptyItem = () => _jsx(View, Object.assign({
    style: inputWidgetStyles.listItemContainer
  }, {
    children: _jsx(Typography, Object.assign({}, getTestId(testID, 'listItemContainer'), {
      type: "body-single-line-xs",
      text: "No Results Found!"
    }))
  }));
  var actionCtaWithOnPressProps = actionCta && Object.assign(Object.assign({}, actionCta), {
    onPress: () => actionCta.onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(actionCta.onPress))
  });
  var onClearButtonPressHandler = () => {
    setValue('');
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onClearButtonPress));
  };
  return _jsxs(_Fragment, {
    children: [_jsx(View, Object.assign({}, getTestId(testID), {
      style: [inputWidgetStyles.container, style]
    }, restProps, {
      children: _jsxs(InView, Object.assign({
        triggerOnce: inViewTriggerOnce,
        onChange: inView => {
          inView && onItemVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onItemVisibleMetaData), {
            value
          }));
        }
      }, {
        children: [_jsx(Input, Object.assign({}, restProps, {
          showDivider: showInputDivider,
          readOnlyOnPress: () => {
            onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onPress), {
              value
            }));
          },
          actionCta: actionCtaWithOnPressProps,
          prependItems: prependItemWithOnPressProps,
          appendItems: appendItemWithOnPressProps,
          style: inputWidgetStyles.input,
          value: value,
          onChangeText: value => {
            var _a;
            !isAutoSelectionItemPressed && filterDataForAutocompleteHandler(value);
            setIsAutoSelectionItemPressed(false);
            setValue(value);
            onChangeTextCallback === null || onChangeTextCallback === void 0 ? void 0 : onChangeTextCallback(value);
            onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, _onChangeText), {
              value,
              formattedValue: (_a = value === null || value === void 0 ? void 0 : value.split('')) === null || _a === void 0 ? void 0 : _a.join(' '),
              widgetData: props
            });
          },
          onHintActionPressHandler: onActionableHintPressHandler,
          onFocus: () => {
            setInputFocus(true);
            filterDataForAutocompleteHandler(value);
            _onFocus && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, _onFocus), {
              value
            }));
          },
          onBlur: () => {
            setTimeout(() => {
              setInputFocus(false);
              _onBlur && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, _onBlur), {
                value
              }));
            }, 150);
          },
          onValidInput: value => {
            _onValidInput && onUserAction(Object.assign({
              id
            }, _onValidInput), {
              value,
              isAutoSelectionItemPressed
            });
          },
          onInValidInput: value => {
            _onInValidInput && onUserAction(Object.assign({
              id
            }, _onInValidInput), {
              value
            });
          },
          onClearButtonPress: onClearButtonPressHandler
        }, getTestId(testID, 'input'))), showAutocomplete && (showListLoader ? _jsx(View, Object.assign({
          style: inputWidgetStyles.autoCompleteContentContainer
        }, {
          children: _jsx(Loader, Object.assign({}, getTestId(testID, 'listLoader'), {
            color: LILAC_600
          }))
        })) : (listData === null || listData === void 0 ? void 0 : listData.length) > 0 || showEmptyItemForAutoComplete ? _jsx(FlatList, Object.assign({
          style: [inputWidgetStyles.autoCompleteContentContainer, autoCompleteStyle],
          data: listData,
          keyboardShouldPersistTaps: autoCompleteKeyboardShouldPersistTaps,
          renderItem: _ref => {
            var item = _ref.item,
              index = _ref.index;
            return _jsx(SingleItem, {
              autocompleteItem: item,
              index: index
            });
          },
          keyExtractor: item => "item_" + (item === null || item === void 0 ? void 0 : item.id),
          ListEmptyComponent: EmptyItem
        }, autoCompleteProps, getTestId(testID, 'list'))) : null)]
      }))
    })), showDivider && _jsx(Divider, {
      height: 1,
      color: LILAC_500,
      style: inputWidgetStyles.inputDivider
    })]
  });
};
InputWidgetComponent.genericRendererKey = 'AirInputWidget';